import { AxiosInstanceProvider } from '../../../core/hooks';
import { L3ServiceApiModel } from '../../../l3-services/model';
import { L3ServiceLocationsHttpQuery } from '../../config';
import { L3ServiceLocationApiModel } from '../../model';

export interface L3ServiceLocationsHttpGetPayloadModel {
  customerId: number;
}

export type L3ServiceLocationsHttpGetResponseModel = L3ServiceLocationApiModel[];

export const getL3ServiceLocations = async (
  axios: AxiosInstanceProvider,
  { customerId }: L3ServiceLocationsHttpGetPayloadModel,
): Promise<L3ServiceLocationsHttpGetResponseModel> => {
  const response = await axios().get<L3ServiceLocationsHttpGetResponseModel>(
    L3ServiceLocationsHttpQuery['GetL3ServiceLocations'].url.replace('{customerId}', customerId.toString(10)),
  );
  return response.data;
};

export interface L3ServiceLocationDetailsHttpGetPayloadModel {
  customerId: number;
  itemId: number;
}

export type L3ServiceLocationDetailsHttpGetResponseModel = L3ServiceApiModel;

export const getL3ServiceDetails = async (
  axios: AxiosInstanceProvider,
  { customerId, itemId }: L3ServiceLocationDetailsHttpGetPayloadModel,
): Promise<L3ServiceLocationDetailsHttpGetResponseModel> => {
  const response = await axios().get<L3ServiceLocationDetailsHttpGetResponseModel>(
    L3ServiceLocationsHttpQuery['GetL3ServiceDetails'].url
      .replace('{customerId}', customerId.toString(10))
      .replace('{itemId}', itemId.toString(10)),
  );
  return response.data;
};

export interface L3ServiceLocationHttpPatchRequestPayloadModel {
  coordinates: {
    latitude: number,
    longitude: number
  }
}

export const patchL3ServiceLocation = async (
  axios: AxiosInstanceProvider,
  customerId: number,
  itemId: number,
  requestPayload: L3ServiceLocationHttpPatchRequestPayloadModel
): Promise<void> => {
  const resourceUrl = L3ServiceLocationsHttpQuery['PatchL3ServiceLocation'].url
    .replace('{customerId}', customerId.toString(10))
    .replace('{itemId}', itemId.toString(10));
  await axios().patch(resourceUrl, requestPayload);
};